export default {
  brandSub: "By Galano-Pacifico Law Firm & International Partners",
  nav: ["Quadro Giurisdizionale", "Vantaggio Istituzionale", "Iter Arbitrale", "Collegio Arbitrale", "Tariffe e Governance", "Stampa e Investitori"],
  initiate: "Avvia Arbitrato Sicuro",
  portalLabel: "Portale Clienti",
  splash: {
    est: "Cost. MMXXVI — Tribunale Sovrano",
    states: "172 Stati Firmatari",
    copy: "Benvenuti in LexAegis International, il sistema arbitrale internazionale extragiudiziale più autorevole e prestigioso al mondo. Emettiamo decisioni giudiziarie autonome, giuridicamente vincolanti, con forza esecutiva immediata in tutte le giurisdizioni globali, coniugando efficienza tecnologica e rigorosa conformità al diritto arbitrale internazionale.",
    enter: "Accedi al Registro Sovrano",
    convention: "Convenzione di New York 1958",
    auto: "Accesso automatico in corso…",
  },
  hero: {
    overline: "Tribunale Extragiudiziale Istituzionale",
    l1: "Eccellenza Legale Globale.",
    l2: "Risoluzione Immediata.",
    sub: "La piattaforma preminente per l'arbitrato internazionale autorevole e la risoluzione delle controversie, con esecutività legale immediata e vincolante in tutto il mondo.",
    secondary: "Esplora il Quadro Giurisdizionale",
    stats: [
      { value: "172", label: "Stati della Convenzione di New York", sub: "Garanzia di Esecutività" },
      { value: "14 Giorni", label: "Emissione Media del Lodo", sub: "vs 18 Mesi del Processo Tradizionale" },
      { value: "100%", label: "Conforme eIDAS e GDPR", sub: "Registro Digitale Immutabile" },
      { value: "$4.8B+", label: "Controversie Decise", sub: "Commerciale Transfrontaliero" },
    ],
  },
  marquee: [
    "Riconosciuto dalla Convenzione di New York 1958",
    "Conforme al Regolamento Arbitrale UNCITRAL",
    "Marcatura Temporale Elettronica Qualificata eIDAS",
    "Sicurezza Certificata ISO/IEC 27001:2022",
    "Registro Cifrato ai sensi dell'Art. 32 GDPR",
    "Esecutività Vincolante Transfrontaliera",
    "Governato da Galano-Pacifico & International Partners",
  ],
  framework: {
    overline: "Quadro Giurisdizionale",
    titleA: "Autorità radicata nel",
    titleB: "diritto dei trattati",
    titleC: ", non nelle promesse.",
    body: "LexAegis non opera in un vuoto giuridico. Ogni ordinanza procedurale, ogni atto sigillato e ogni lodo finale è progettato per superare i più rigorosi test del diritto arbitrale internazionale — affinché l'esito sia efficace ovunque risieda la controparte.",
    artLabel: "Riconoscimento ed Esecuzione",
    pillars: [
      { title: "Convenzione di New York del 1958", body: "I lodi emessi dal tribunale LexAegis sono riconoscibili ed eseguibili in tutti i 172 Stati contraenti, senza una nuova lite sul merito dinanzi ai giudici nazionali." },
      { title: "Regole Modello UNCITRAL", body: "La condotta procedurale segue il Regolamento Arbitrale UNCITRAL, garantendo il giusto processo, la parità delle parti e il pieno diritto di rappresentanza in ogni fase." },
      { title: "Esecuzione Transfrontaliera", body: "I lodi certificati sono trasmessi direttamente ai registri esecutivi, alle reti di ufficiali giudiziari e ai canali legali diplomatici nella giurisdizione della parte resistente." },
    ],
  },
  advantage: {
    overline: "Il Paradigma LexAegis",
    titleA: "Integrità Giudiziaria",
    titleB: "a Doppio Livello",
    body: "La selezione probatoria automatizzata e i fascicoli digitali asincroni accelerano il procedimento — ma ogni decisione finale è resa esclusivamente da arbitri, giuristi ed ex magistrati accreditati. La tecnologia serve il diritto; non sostituisce mai il giudizio.",
    guarantee: "Garanzia Istituzionale",
    items: [
      { title: "Selezione Giurisdizionale Assistita dall'IA", desc: "Riferimento incrociato automatizzato di trattati internazionali, clausole di elezione del foro e principi di conflitto di leggi per stabilire istantaneamente la giurisdizione prima facie.", badge: "Rigore Automatizzato" },
      { title: "Collegio Arbitrale d'Élite", desc: "Ex magistrati di alta corte, arbitri accreditati e giuristi internazionali specializzati esaminano personalmente ed emettono i lodi vincolanti finali.", badge: "Autorità Umana" },
      { title: "Marcatura Temporale eIDAS Immutabile", desc: "Ogni deposito probatorio, memoria e ordinanza procedurale è sigillato crittograficamente con marcature temporali di valore legale.", badge: "Sigillo Probatorio" },
      { title: "Esecuzione ex Convenzione di New York", desc: "I lodi emessi sono direttamente eseguibili in 172 nazioni firmatarie ai sensi del diritto internazionale, superando i colli di bottiglia giudiziari statali.", badge: "Esecuzione Globale" },
    ],
  },
  workflow: {
    overline: "Manifesto e Procedura",
    titleA: "Il Protocollo Arbitrale",
    titleB: "in 4 Fasi",
    side: "Dal deposito della domanda al lodo vincolante ed eseguibile transfrontaliero — una catena procedurale disciplinata, senza vicoli ciechi.",
    note: "Nota Procedurale",
    steps: [
      { title: "Onboarding Intelligente e Validazione Giurisdizionale", desc: "La parte attrice presenta i parametri della controversia e la clausola compromissoria. I sistemi automatizzati LexAegis verificano la legittimazione dei firmatari e l'idoneità del foro.", details: "Include calcolatore del valore della lite, notifica alla parte resistente e verifica giurisdizionale iniziale secondo le regole UNCITRAL." },
      { title: "Fascicolo Digitale Sicuro e Atti Sigillati", desc: "Le parti accedono a una camera virtuale crittografata end-to-end. Prove, domande riconvenzionali e memorie sono marcate temporalmente secondo gli standard eIDAS.", details: "Controllo degli accessi zero-trust con archiviazione AES-256 e sistema di notifica multi-giurisdizionale istantaneo." },
      { title: "Revisione Legale Preliminare IA e Udienza del Collegio", desc: "Il nostro motore neurale pre-seleziona giurisprudenza e clausole contrattuali prima di trasmettere il fascicolo agli arbitri senior assegnati.", details: "Condotta tramite testimonianza digitale asincrona o sessioni opzionali di tribunale virtuale crittografate." },
      { title: "Emissione del Lodo Arbitrale Vincolante Definitivo", desc: "Il tribunale emette un lodo definitivo, non appellabile, con motivazione giuridica completa, certificato per l'esecuzione transfrontaliera ai sensi della Convenzione di New York.", details: "Trasmissione diretta agli ufficiali giudiziari locali e ai registri legali diplomatici su richiesta." },
    ],
  },
  panel: {
    overline: "Giuristi Verificati",
    titleA: "Un Collegio Arbitrale",
    titleB: "Illustre",
    body: "Arbitri internazionali indipendenti, impegnati in assoluta imparzialità e precisione giuridica. Credenziali verificate presso gli enti emittenti.",
    verified: "Verificato",
    awards: "Lodi Emessi",
    members: [
      { role: "Ex Magistrato di Alta Corte", spec: "Arbitrato Commerciale Internazionale e Marittimo", jur: "Londra / Singapore — Accreditata LCIA e SIAC" },
      { role: "Arbitro Senior e Giurista IP", spec: "Controversie Tecnologiche e Brevettuali Transfrontaliere", jur: "Ginevra / Zurigo — Neutrale WIPO" },
      { role: "Cattedra Emerita di Diritto Internazionale", spec: "Controversie tra Stati Sovrani e Investitori", jur: "L'Aia / Vienna — Membro del Panel ICSID" },
    ],
  },
  pricing: {
    overline: "Tariffario Trasparente",
    titleA: "Tariffe Arbitrali",
    titleB: "a Scaglioni Fissi",
    body: "Nessuna tariffa oraria nascosta. Spese amministrative e onorari del collegio trasparenti, calcolati sul valore complessivo della lite — prevedibilità totale rispetto al contenzioso giudiziario tradizionale.",
    calcLabel: "Valore della Lite (USD)",
    calcPlaceholder: "es. 480000",
    calcEmpty: "Inserisci per abbinare lo scaglione",
    tierPrefix: "Scaglione",
    matched: "Abbinato alla tua Lite",
    mostRetained: "Il Più Scelto",
    cta: "Avvia in Questo Scaglione",
    tiers: [
      { name: "Commerciale Standard", range: "Liti fino a 250.000 USD", feeSuffix: "USD Fisso", timeframe: "Risoluzione rapida in 10 giorni", features: ["Nomina di Arbitro Unico", "Fascicolo Digitale Asincrono", "Sintesi Probatoria Pre-Triage IA", "Lodo Certificato ex Convenzione NY", "Accesso al Portale Cifrato 24/7"] },
      { name: "Enterprise e Corporate", range: "Liti da 250.000 a 2.500.000 USD", feeSuffix: "USD Fisso", timeframe: "Decisione formale in 14 giorni", features: ["Opzione Collegio a 3 Membri", "Esame di Misure Cautelari d'Emergenza", "Analisi Giurisdizionale IA Prioritaria", "Camera di Udienza Orale Virtuale", "Notifica Transfrontaliera Diretta", "Cancelliere Legale Dedicato"] },
      { name: "Sovrano e Complesso", range: "Liti oltre 2.500.000 USD", feeSuffix: "Tariffario Legale su Misura", timeframe: "Iter celere o personalizzato", features: ["Selezione Personalizzata dal Collegio", "Risoluzione di Conflitti Multi-Giurisdizionali", "Protocolli di Riservatezza Su Misura", "Supporto Esecutivo in Sede Diplomatica", "Team di Operazioni Legali Concierge"] },
    ],
  },
  intake: {
    channel: "Canale Cifrato AES-256",
    title: "Avvia Arbitrato Sicuro",
    desc: "Compila il modulo di seguito per depositare una domanda arbitrale formale nel registro sovrano.",
    claimant: "Parte Attrice / Nome Completo",
    respondent: "Parte Resistente / Nome Completo",
    claimValue: "Valore Stimato della Lite (USD)",
    jurisdiction: "Legge Applicabile / Giurisdizione",
    email: "Email di Contatto per le Conferme",
    summary: "Sintesi della Controversia e Riferimento alla Clausola",
    phClaimant: "es. Meridian Trading S.A.",
    phRespondent: "es. Novatek Logistics GmbH",
    phClaim: "480000",
    phSummary: "Descrivi la controversia e cita la clausola compromissoria (es. Clausola 14.2 del Contratto di Fornitura)…",
    submit: "Deposita l'Atto e Genera il Numero di Riferimento",
    submitting: "Sigillatura del Fascicolo…",
    footnote: "Deposito conforme all'Art. 32 GDPR · Marcatura temporale eIDAS · Protetto e Riservato",
    successTitle: "Atto Depositato — Riferimento {ref}",
    successBody: "La tua domanda arbitrale è stata registrata nel fascicolo sicuro. Un cancelliere LexAegis ti contatterà entro un giorno lavorativo.",
    errorTitle: "Deposito respinto",
    errorBody: "Verifica tutti i campi e invia nuovamente.",
  },
  portal: {
    tag: "Protetto 2FA · ISO 27001",
    title: "Portale Sicuro del Giudicante",
    email: "Email Registrata",
    password: "Password",
    token: "Codice Token Hardware (6 cifre)",
    submit: "Autenticazione Sicura",
    verifying: "Verifica delle Credenziali…",
    welcome: "Sessione Autenticata",
    dockets: "Fascicoli Arbitrali Depositati",
    inquiries: "Richieste Stampa e Investitori",
    logout: "Esci",
    empty: "Nessun record nel fascicolo.",
    errorInvalid: "Credenziali non valide o account bloccato. Verifica e riprova.",
    statusLabel: "Stato",
    statusLabels: ["Atto Depositato", "In Esame", "Udienza Fissata", "Lodo Emesso"],
    downloadPdf: "Esporta PDF",
    updated: "Stato aggiornato",
    footnote: "Accesso riservato ad arbitri incaricati e legali registrati",
    toastTitle: "Portale Dimostrativo",
    toastBody: "Le credenziali di arbitri e legali sono rilasciate esclusivamente dalla cancelleria di Galano-Pacifico. Questa anteprima non concede accesso al fascicolo.",
  },
  press: {
    overline: "Ufficio Stampa e Investor Relations",
    titleA: "Desk",
    titleB: "Stampa & Investitori",
    body: "Giornalisti accreditati e investitori istituzionali possono contattare l'ufficio comunicazione di LexAegis tramite questo canale cifrato. Ogni richiesta è gestita con assoluta riservatezza dall'ufficio relazioni pubbliche di Galano-Pacifico.",
    secureNote: "Canale cifrato PGP · Risposta entro 24 ore",
    fullName: "Nome e Cognome",
    org: "Testata Giornalistica / Società di Investimento",
    email: "Email Professionale",
    type: "Tipo di Richiesta",
    message: "Messaggio",
    types: ["Richiesta Press Kit", "Intervista ai Media", "Briefing Investor Relations", "Panoramica Finanziaria"],
    phName: "es. Alessandra Rinaldi",
    phOrg: "es. Il Sole 24 Ore / Meridian Capital",
    phMessage: "Descrivi la richiesta, la scadenza e il livello del portavoce richiesto…",
    submit: "Invia Richiesta Sicura",
    downloadKit: "Scarica il Press Kit (PDF)",
    again: "Invia un'Altra Richiesta",
    submitting: "Cifratura e Invio in corso…",
    footnote: "Le richieste sono riservate, conformi all'Art. 32 GDPR e mai condivise con terzi.",
    successTitle: "Richiesta Ricevuta — Riferimento {ref}",
    successBody: "La tua richiesta è stata registrata presso l'ufficio comunicazione. Riceverai risposta entro 24 ore.",
    errorTitle: "Invio respinto",
    errorBody: "Verifica tutti i campi e invia nuovamente.",
  },
  footer: {
    compliance: "Gestito rigorosamente ai sensi delle norme sull'arbitrato commerciale internazionale, della Convenzione sul Riconoscimento e l'Esecuzione dei Lodi Arbitrali Stranieri del 1958 e delle regole UNCITRAL. Tutti i dati del fascicolo sono trattati ai sensi dell'Art. 32 GDPR con crittografia AES-256 a riposo e in transito.",
    institutional: "Istituzionale",
    links: ["Regole Giurisdizionali", "Codice Deontologico Giudiziario", "Collegio Arbitrale", "Tariffario e Calcolatore", "Vantaggio Istituzionale", "Ufficio Stampa e Investitori"],
    secureTitle: "Accesso Sicuro",
    secureBody: "Gli arbitri incaricati e i legali registrati possono accedere ai fascicoli sigillati tramite il portale protetto.",
    portalBtn: "Portale Sicuro del Giudicante",
    ethics: "Codice Deontologico Professionale: ogni giurista incaricato è vincolato alle Linee Guida IBA sui Conflitti di Interesse nell'Arbitrato Internazionale.",
    copyright: "© 2026 LexAegis International — By Galano-Pacifico Law Firm & International Partners. Tutti i diritti riservati.",
    sovereign: "Tribunale Extragiudiziale Sovrano",
  },
};
